import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CreateUserCustomDomainBody, UserCustomDomainAPI } from 'api';

export const createUserCustomDomain = createAsyncThunk(
  'userCustomDomain/createUserCustomDomain',
  async (body: CreateUserCustomDomainBody, { rejectWithValue }) => {
    try {
      const response = await UserCustomDomainAPI.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findUserCustomDomainWithEntity = createAsyncThunk(
  'userCustomDomain/findUserCustomDomainWithEntity',
  async (any, { rejectWithValue }) => {
    try {
      const response = await UserCustomDomainAPI.findCustomDomainWithEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateUserCustomDomain = createAsyncThunk(
  'userCustomDomain/updateUserCustomDomain',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await UserCustomDomainAPI.update(option.id, option.body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: any[];
}

const initState: IState = {
  list: [],
};

const userCustomDomainSlice = createSlice({
  name: 'userCustomDomain',
  initialState: initState,
  reducers: {},
});

const { reducer: userCustomDomainReducer } = userCustomDomainSlice;

export default userCustomDomainReducer;
